'use client';

import { usePathname } from 'next/navigation'
import { ArrowLeft, ExternalLink } from 'lucide-react'
import Link from 'next/link';
import { Button } from './ui/button';


export function Nav() {
  const paths = usePathname()
  const pathNames = paths.split('/').filter( path => path )

  return (
    pathNames.length > 1 && 
      <nav className="flex flex-col items-center justify-between bg-primary-foreground">
        <div className="w-full flex md:px-4 pt-4 pb-2 md:pb-0">
          {pathNames.length == 2 &&
            <Button variant="link" asChild><Link className="underline hover:no-underline" href={`/${pathNames.slice(0, 1).join('/')}`}><ArrowLeft className="w-4 h-4 mr-2"/> Coverage Options</Link></Button>
          }
          {pathNames.length == 3 &&
            <Button variant="link" asChild><Link className="underline hover:no-underline" href={`/${pathNames.slice(0, 2).join('/')}`}><ArrowLeft className="w-4 h-4 mr-2"/> Back</Link></Button>
          }
          <div className="flex-1"></div>
          <Button variant="link" asChild>
            <Link className="underline hover:no-underline" href='https://customers.verticalinsure.com' target='_blank'>My Account <ExternalLink className="h-4 w-4 ml-2"/></Link>
          </Button>
        </div>
      </nav>
  )
}